const CROSSFADE_DURATION_MS = 150;
const wrapperCls = "_61w1xvjxtl";
const transitionWrapperCls = "_61txw0mya";
const breadcrumbsCls = "_61b1457g20";
const breadcrumbCls = "_61b1rriudi";
const subNavigationButtonCls = "_61s1r5ewj9";
const chevronCls = "_61cg8omt6";
const labelCls = "_61l6vik8y";
const outlineCls = "_61ostspk2";
const linkCls = "_61l1bg0nde";
const truncateCls = "_61t1ngnsyt";

export { CROSSFADE_DURATION_MS, breadcrumbCls, breadcrumbsCls, chevronCls, labelCls, linkCls, outlineCls, subNavigationButtonCls, transitionWrapperCls, truncateCls, wrapperCls };
import "./root.breadcrumb.style.linaria.module.css";
//# sourceMappingURL=root.breadcrumb.style.js.map
